'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schedule = undefined;

var _helpers = require('../common/helpers');

var PAGE_LOADED_TIME = Date.now();
var PAGE_LOAD_DEFER_TIMER = 6000;
var DEBOUNCE_TIMER = 2000;

var hasDeferredExecution = false;
var pageHasLoaded = false;

var getTimeSincePageLoad = function getTimeSincePageLoad() {
  return Date.now() - PAGE_LOADED_TIME;
};

var shouldDefer = function shouldDefer() {
  if (pageHasLoaded) {
    return false;
  }

  return getTimeSincePageLoad() < PAGE_LOAD_DEFER_TIMER;
};

var execute = function execute(callback) {
  return callback();
};

var deferredExecution = function deferredExecution() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (hasDeferredExecution) {
    return;
  }

  setTimeout(function () {
    execute.apply(undefined, args);
    pageHasLoaded = true;
  }, PAGE_LOAD_DEFER_TIMER - getTimeSincePageLoad());
  hasDeferredExecution = true;
};

var debouncedExecution = (0, _helpers.debounce)(execute, DEBOUNCE_TIMER);

var schedule = exports.schedule = function schedule() {
  if (shouldDefer()) {
    deferredExecution.apply(undefined, arguments);
  } else {
    debouncedExecution.apply(undefined, arguments);
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/scheduler/index.js
// module id = 1249
// module chunks = 3